import React from "react"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import autobind from "class-autobind"
import { IPayClass } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import EditIcon from "material-ui/svg-icons/image/edit"
import { grey500 } from "material-ui/styles/colors"
import AddPayClassDialog from "./AddPayClassDialog"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import * as utils from "../../../helpers/utils"

interface IProps {
    hidePayInfo?: boolean
    readonly: boolean
    style?: React.CSSProperties
    labelStyle?: React.CSSProperties
    iconStyle?: React.CSSProperties
    defaultPayClass: IPayClass
    availablePayClasses: IPayClass[]
    selectedPayClassId: string
    availablePayTypeIds?: string[]
    keepPropsPayClassId?: boolean
    // we need to set new Id for selected payclass when customize the selected payclass
    handleChange(availablePayClasses: IPayClass[], defaultPayClass: IPayClass, selectedPayClassId: string): void

    //Employee->Timecard->PunchDrawerTable
    isPunchListTable?: boolean
}
interface IState {
    selectedPayClassId: string
    defaultPayClass: IPayClass
    availablePayClasses: IPayClass[]
    openCustomPayClassDialog: boolean
}

export default class PayClassSelector extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedPayClassId: props.selectedPayClassId,
            defaultPayClass: props.defaultPayClass,
            availablePayClasses: props.availablePayClasses || [],
            openCustomPayClassDialog: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.setSelectedPayClass(this.props, true)
    }

    componentWillReceiveProps(nextProps) {
        !_.isEqual(this.props.availablePayClasses, nextProps.availablePayClasses) &&
            this.setState({ availablePayClasses: nextProps.availablePayClasses }, () => this.setSelectedPayClass(nextProps, false))
    }

    setSelectedPayClass(props: IProps, firstLoading: boolean) {
        const selectedPayClassId = (props.keepPropsPayClassId && firstLoading) ?
            this.state.selectedPayClassId :
            this.state.availablePayClasses && this.state.availablePayClasses.find(i => i.Id === this.state.selectedPayClassId) ?
                this.state.selectedPayClassId :
                props.defaultPayClass ?
                    props.defaultPayClass.Id :
                    null

        this.setState({ selectedPayClassId, defaultPayClass: this.props.defaultPayClass }, () =>
            this.handleChange()
        )
    }

    handleChange() {
        this.props.handleChange(this.state.availablePayClasses, this.state.defaultPayClass, this.state.selectedPayClassId)
    }

    render() {
        const selectedPayClass = this.state.availablePayClasses ? this.state.availablePayClasses.find(i => i.Id === this.state.selectedPayClassId) : null
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })
        return (
            <div style={{ position: "relative" }}>
                <SelectField
                    data-intercom-target={"Select-PayClass"}
                    autoWidth
                    title={selectedPayClass ? selectedPayClass.Name : null}
                    floatingLabelText={this.props.isPunchListTable ? "" : strings.Pay_Class}
                    style={this.props.style}
                    labelStyle={this.props.labelStyle}
                    iconStyle={this.props.iconStyle ? this.props.iconStyle : { width: 40 }}
                    value={this.state.selectedPayClassId}
                    onChange={(object, key, payload) => this.setState({ selectedPayClassId: payload }, () =>
                        this.handleChange()
                    )}
                    disabled={this.props.readonly}
                >
                    {this.props.keepPropsPayClassId && !selectedPayClass &&
                        <MenuItem value={null} primaryText={""} />
                    }
                    {this.state.availablePayClasses.map((payClass, index) =>
                        <MenuItem value={payClass.Id} primaryText={payClass.Name} key={index} />
                    )}
                </SelectField>
                {selectedPayClass && !this.props.readonly &&
                    <EditIcon
                        title={strings.Custom_Pay_Class}
                        style={{ color: grey500, cursor: "pointer", position: "absolute", top: this.props.isPunchListTable ? 12 : 40, width: this.props.isPunchListTable ? 15 : 20, height: this.props.isPunchListTable ? 15 : 20 }}
                        onTouchTap={() => this.setState({ openCustomPayClassDialog: true })}
                    />
                }
                {permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
                    !this.props.hidePayInfo && selectedPayClass && selectedPayClass.PayTypeId && (selectedPayClass.PayInfo.PayRate > 0 || selectedPayClass.PayInfo.BillRate > 0) &&
                    <div style={{ color: "#aaaaaa", fontSize: 12, position: "absolute", top: 63, width: "max-content" }}>
                        {selectedPayClass.PayInfo.PayRate ?
                            <span>
                                <strong>{strings.Pay_Rate}:</strong> {formatter.format(selectedPayClass.PayInfo.PayRate)}
                            </span>
                            : null
                        }
                        {selectedPayClass.PayInfo.BillRate ?
                            <span>
                                <strong style={{ marginLeft: 5 }}>{strings.Bill_Rate}:</strong> {formatter.format(selectedPayClass.PayInfo.BillRate)}
                            </span>
                            : null
                        }
                        {selectedPayClass.PayInfo.Burden > 0 &&
                            <span>
                                <strong style={{ marginLeft: 5 }}>{strings.Burden}:</strong> {selectedPayClass.PayInfo.Burden}%
                            </span>
                        }
                    </div>
                }
                {this.state.openCustomPayClassDialog &&
                    <AddPayClassDialog
                        editPayClass={_.cloneDeep(selectedPayClass)}
                        existingPayClasses={this.state.availablePayClasses}
                        handleClose={() => this.setState({ openCustomPayClassDialog: false })}
                        availablePayTypeIds={this.props.availablePayTypeIds}
                        handleAdd={() => { }}
                        handleUpdate={payClass => {
                            if (!_.isEqual(payClass, selectedPayClass)) {
                                const updatedDefaultPayClass = selectedPayClass.Id === this.state.defaultPayClass.Id
                                const indexOf = this.state.availablePayClasses.findIndex(i => i.Id === selectedPayClass.Id)
                                payClass.Id = utils.guid()
                                const { availablePayClasses } = this.state
                                availablePayClasses[indexOf] = payClass
                                this.setState({
                                    defaultPayClass: updatedDefaultPayClass ? payClass : this.state.defaultPayClass,
                                    availablePayClasses,
                                    selectedPayClassId: payClass.Id
                                }, () =>
                                    this.handleChange()
                                )
                            }
                            this.setState({ openCustomPayClassDialog: false })
                        }}
                    />
                }
            </div>
        )
    }
}
